module.exports = __webpack_public_path__ + "img/lotd_1.0fa1e643.png";